export default __webpack_public_path__ + "static/tropicana_swirl-324c7486ba4d68dcdd099de76f494efc.png";